import AuthServices from "../../services/AuthServices";
import Utils from "@/utils/Utils";
const authService = new AuthServices();
import RouterUtils from "../../utils/BaseUtils/RouterUtils";
import StoreUtils from "../../utils/BaseUtils/StoreUtils";
import LoaderUtils from "../../utils/BaseUtils/LoaderUtils";
import NotificationUtils from "../../utils/BaseUtils/NotificationUtils";
import AppUtils from "../../utils/BaseUtils/AppUtils";
import AuthRequest from "@/model/requests/AuthRequest";
import AuthResponse from "@/model/responses/AuthResponse";

export const namespaced = true;

export const state = {
  businessId: "",
  degrees: [],
  applicantMobileNumber: "",
  startingEducationDate: "",
  endEducationDate: "",
  userRegToken: "",
  startingEmploymentDate: "",
  endEmploymentDate: "",
  startingProjectDate: "",
  endProjectDate: "",
  recruiterActionModalOpen: false,
  applicantRegSkills: [],
  selectedSkill: "",
  userEmail: "",
  userPassword: "",
  userType: "applicant",
  changePasswordSuccess: false,
  screen: "register",
  userInfo: {},
  resetScreen: "reset",
  password: "",
  passwordConfirm: "",
  resetPassword: "",
  resetPasswordConfirm: "",
  authEmail: "",
  countryCode: "",
  otpLoading: false,
  userPhoneNo: "",
  userCountryCode: "",
  load: false
};

export const getters = {
  getAuthToken: state => {
    return state.token;
  },
  getUserRegToken: state => {
    return state.userRegToken;
  },
  getAuthBusinessId: state => {
    return state.businessId;
  },
  getMobileNumber: state => {
    return state.applicantMobileNumber;
  },
  getEmail: state => {
    return state.userEmail;
  },
  getPassword: state => {
    return state.userPassword;
  },
  getSelectedSkill: state => {
    return state.selectedSkill;
  },
  getStartEducationDate: state => {
    return state.startingEducationDate;
  },
  getApplicantId: state => {
    return state.applicantId;
  },
  getRecruiterId: state => {
    return state.recruiterId;
  },
  getEndEducationDate: state => {
    return state.endEducationDate;
  },
  getStartEmploymentDate: state => {
    return state.startingEmploymentDate;
  },
  getEndEmploymentDate: state => {
    return state.endEmploymentDate;
  },
  getStartProjectDate: state => {
    return state.startingProjectDate;
  },
  getEndProjectDate: state => {
    return state.endProjectDate;
  },
  getActionModalOpen: state => {
    return state.recruiterActionModalOpen;
  },
  getApplicantRegSkills: state => {
    return state.applicantRegSkills;
  },
  getUserType: state => {
    return state.userType;
  },
  getChangePasswordSuccess: state => {
    return state.changePasswordSuccess;
  },
  getDegrees: state => {
    return state.degrees;
  },
  getUserInfo: state => {
    return state.userInfo;
  },
  getCustomerStripeId: state => {
    return state.userInfo.customerStripeId;
  },
  getCustomerId: state => {
    return state.userInfo.customerId;
  }
};

export const mutations = {
  updateScreen: (state, payload) => {
    state.screen = payload;
  },
  updateUserInfo: (state, payload) => {
    state.userInfo = payload;
  },
  updateResetScreen: (state, payload) => {
    state.resetScreen = payload;
  },
  updateProfilePicture: (state, payload) => {
    state.userInfo.customerDisplayPicture = payload;
  },

  SET_APPLICANT_ID(state, payload) {
    state.applicantId = payload;
  },
  SET_USER_REG_TOKEN(state, payload) {
    state.userRegToken = payload;
  },
  SET_RECRUITER_ID(state, payload) {
    state.recruiterId = payload;
  },
  RESET_AUTH_TOKEN(state) {
    state.token = `Key ...hfhfgfhfjhfj9484874734..kdkhd2345jdfkdj36472*Khgioojss222...`;
  },
  SET_AUTH_BUSINESS_ID(state, payload) {
    state.businessId = payload;
  },
  SET_MOBILE_NUMBER(state, payload) {
    state.applicantMobileNumber = payload;
  },
  SET_EMAIL(state, payload) {
    state.userEmail = payload;
  },
  SET_PASSWORD(state, payload) {
    state.userPassword = payload;
  },
  SET_START_EDU_DATE(state, payload) {
    state.startingEducationDate = payload;
  },
  SET_END_EDU_DATE(state, payload) {
    state.endEducationDate = payload;
  },
  SET_START_EMP_DATE(state, payload) {
    state.startingEmploymentDate = payload;
  },
  SET_END_EMP_DATE(state, payload) {
    state.endEmploymentDate = payload;
  },
  SET_START_PRO_DATE(state, payload) {
    state.startingProjectDate = payload;
  },
  SET_END_PRO_DATE(state, payload) {
    state.endProjectDate = payload;
  },
  SET_SELECTED_SKILL(state, payload) {
    state.selectedSkill = payload;
  },
  SET_ACTION_MODAL_OPEN(state, payload) {
    state.recruiterActionModalOpen = payload;
  },
  SET_APPLICANT_REG_SKILLS(state, payload) {
    state.applicantRegSkills = payload;
  },
  SET_USER_TYPE(state, payload) {
    state.userType = payload;
  },
  SET_CHANGE_PASSWORD_SUCCESS(state, payload) {
    state.changePasswordSuccess = payload;
  },
  SET_DEGREES(state, payload) {
    state.degrees = payload;
  },
  setPassword(state, payload) {
    state.password = payload;
  },
  setPasswordConfirm(state, payload) {
    state.passwordConfirm = payload;
  },
  setResetPassword(state, payload) {
    state.resetPassword = payload;
  },
  setResetPasswordConfirm(state, payload) {
    state.resetPasswordConfirm = payload;
  },
  setEmail(state, payload) {
    state.authEmail = payload;
  },
  setCountryCode(state, payload) {
    state.countryCode = payload;
  },
  setOtpLoading(state, payload) {
    state.otpLoading = payload;
  },
  setUserCountryCode(state, payload) {
    state.userCountryCode = payload;
  },
  setUserPhoneNo(state, payload) {
    state.userPhoneNo = payload;
  },
  updateLoad(state, payload) {
    state.load = payload;
  }
};

export const actions = {
  timeslotLogin({ commit }, payload = AuthRequest.login) {
    let successAction = responseData => {
      Utils.saveToLocalStorage("token", responseData.token);
      commit("updateUserInfo", responseData);
      StoreUtils.dispatch("form/resetForm");
      let customer = { customerId: responseData.customerId };
      StoreUtils.commit("customer/updateCustomerId", responseData.customerId);
      StoreUtils.dispatch("customer/readByCustomerId", customer);
      StoreUtils.dispatch("wallet/readWallet", {
        customerId: responseData.customerId
      });
      StoreUtils.dispatch("groupSession/readUserGroupSessions");
      if (Object.keys(sessionStorage).length > 0) {
        RouterUtils.changeRouteUrlTo(sessionStorage.getItem("target"));
      } else {
        if (responseData.userRole.toLowerCase() === "customer") {
          RouterUtils.changeRouteTo(RouterUtils.routes.auth.CUSTOMER_DASHBOARD);
        } else {
          let professional = {
            professionalId: responseData.professional.professionalId
          };
          StoreUtils.dispatch(
            "professional/readByProfessionalId",
            professional
          );
          StoreUtils.commit(
            "professional/updateProfessionalInfo",
            responseData.professional
          );
          StoreUtils.commit(
            "professional/updateProfessionalId",
            responseData.professional.professionalId
          );

          RouterUtils.changeRouteTo(
            RouterUtils.routes.auth.PROFESSIONAL_DASHBOARD
          );
        }
      }
      let notify = { notificationRecipient: responseData.customerId };
      StoreUtils.dispatch("notificationMessage/readNotifications", notify);
      let pendingId = { customerId: responseData.customerId };
      StoreUtils.dispatch("booking/readPendingReviews", pendingId);
    };
    return authService.timeslotLogin(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },

  startEnrollment({ commit }, payload = AuthRequest.initiateEnrollment) {
    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      // commit("updateScreen", "otp");
      RouterUtils.changeRouteUrlTo("/set-password");
    };

    return authService.startEnrollment(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  endEnrollment({ commit }, payload = AuthRequest.completeEnrollment) {
    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      RouterUtils.changeRouteUrlTo("/success");
      // commit("updateScreen", "success");
    };

    return authService.endEnrollment(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },

  googleEnrollment({ commit }, payload = AuthRequest.googleSignUp) {
    let successAction = () => {};
    return authService.googleEnrollment(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },

  resendOtp({ commit }, payload = AuthRequest.resendOtp) {
    StoreUtils.commit("auth/setOtpLoading", true);

    let successAction = () => {
      // StoreUtils.dispatch("form/resetForm");
      StoreUtils.commit("auth/setOtpLoading", false);
    };

    return authService.resendOtp(
      payload,
      successAction,
      LoaderUtils.types.NONE
    );
  },
  initiatePasswordReset(
    { commit },
    payload = AuthRequest.initiatePasswordReset
  ) {
    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      RouterUtils.changeRouteUrlTo("/new-password");
    };
    return authService.initiatePasswordReset(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  completePasswordReset(
    { commit },
    payload = AuthRequest.completePasswordReset
  ) {
    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      RouterUtils.changeRouteUrlTo("/reset-success");
    };
    return authService.completePasswordReset(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  changePassword({ commit }, payload = AuthRequest.changePassword) {
    let successAction = () => {
      commit("SET_CHANGE_PASSWORD_SUCCESS", true);
    };
    return authService.changePassword(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  logout({ commit }) {
    commit("updateUserInfo", null);
    Utils.clearLocalStorage();
    window.location.href = "/login";
    sessionStorage.clear();
  },
  userDetails({ commit }, payload = AuthRequest.userDetails) {
    let successAction = responseData => {
      commit("updateUserInfo", responseData);
    };
    return authService.userDetails(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },

  createApplicant() {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );

    let payload = {
      email: formBody.email,
      password: formBody.password,
      address: formBody.address,
      link: "45",
      firstname: formBody.firstname,
      lastname: formBody.lastname,
      mobilenumber: formBody.mobilenumber,
      gender: formBody.gender,
      username: formBody.email
    };

    StoreUtils.commit("auth/SET_MOBILE_NUMBER", formBody.mobilenumber);
    StoreUtils.commit(StoreUtils.mutations.auth.SET_EMAIL, formBody.email);

    let successAction = responseData => {
      StoreUtils.dispatch("form/resetForm");
      //Save Applicant ID
      // Utils.saveToLocalStorage(
      //   StoreUtils.localStorageStore.auth.APPLICANT_ID,
      //   responseData.userid
      // );
      RouterUtils.changeRouteTo(RouterUtils.routes.auth.CONFIRM_OTP);
    };

    authService.createApplicant(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },

  forgotPassword() {
    let email = StoreUtils.rootGetters("auth/getEmail");

    let payload = {
      emailorphone: email
    };

    let successAction = () => {
      //  move to confirm otp
      // StoreUtils.dispatch("form/increaseFormStageByOne");
      // StoreUtils.dispatch("form/resetFormBody");
      RouterUtils.changeRouteTo(
        RouterUtils.routes.auth.CONFIRM_FORGOT_PASSWORD_OTP
      );
      StoreUtils.dispatch("form/resetForm");
    };

    authService.forgotPassword(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  confirmOtp() {
    let mobile = StoreUtils.rootGetters("auth/getMobileNumber");
    let otp = StoreUtils.rootGetters(
      StoreUtils.getters.auth.GET_USER_REG_TOKEN
    );

    let payload = {
      mobilenumber: mobile,
      otp: otp
    };

    let successAction = () => {
      //move to applicant profile
      // RouterUtils.changeRouteTo(RouterUtils.routes.auth.APPLICANT_PROFILE);
      RouterUtils.changeRouteTo(RouterUtils.routes.auth.LOGIN);
      StoreUtils.dispatch("form/resetForm");
    };

    authService.confirmOtp(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  confirmForgotPasswordOtp() {
    let email = StoreUtils.rootGetters("auth/getEmail");
    let password = StoreUtils.rootGetters("auth/getPassword");
    let otp = StoreUtils.rootGetters(
      StoreUtils.getters.auth.GET_USER_REG_TOKEN
    );

    let payload = {
      emailorphone: email,
      password: password,
      otp: otp
    };

    let successAction = () => {
      //change route to login form
      RouterUtils.changeRouteTo(RouterUtils.routes.auth.LOGIN);
      StoreUtils.dispatch("form/resetForm");
    };

    authService.confirmForgotPasswordOtp(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },

  // resendOtp() {
  //   let email = StoreUtils.rootGetters(StoreUtils.getters.auth.GET_EMAIL);
  //
  //   let payload = {
  //     email: email
  //   };
  //
  //   let successAction = () => {
  //     //resend otp to email
  //     StoreUtils.commit(
  //       StoreUtils.mutations.auth.SET_USER_REG_TOKEN,
  //       this.userRegToken
  //     );
  //     StoreUtils.dispatch("form/resetForm");
  //   };
  //
  //   authService.resendOtp(
  //     payload,
  //     successAction,
  //     LoaderUtils.types.NONBLOCKING
  //   );
  // },

  addEducation() {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );

    let payload = {
      university: formBody.university,
      courseofstudy: formBody.course,
      degree: formBody.degree,
      startdate: formBody.startdate,
      enddate: formBody.enddate,
      cgpa: "4.5",
      applicantid: StoreUtils.rootGetters(
        StoreUtils.getters.applicant.GET_APPLICANT_ID
      )
    };

    let successAction = () => {
      RouterUtils.changeRouteTo(RouterUtils.routes.auth.ADD_EMPLOYMENT);
      StoreUtils.dispatch(StoreUtils.actions.applicant.FETCH_EDUCATION_HISTORY);
      StoreUtils.dispatch("form/resetForm");
    };

    authService.addEducation(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },

  addEmployment() {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );

    let payload = {
      organisationname: formBody.organisationname,
      jobtitle: formBody.jobtitle,
      description: formBody.description,
      applicantid: StoreUtils.rootGetters(
        StoreUtils.getters.applicant.GET_APPLICANT_ID
      ),
      startdate: StoreUtils.rootGetters("auth/getStartEmploymentDate"),
      enddate: StoreUtils.rootGetters("auth/getEndEmploymentDate")
    };

    let successAction = responseData => {
      //fetch employment
      StoreUtils.dispatch(
        StoreUtils.actions.applicant.FETCH_EMPLOYMENT_HISTORY
      );

      RouterUtils.changeRouteTo(RouterUtils.routes.auth.ADD_PROJECT);

      StoreUtils.dispatch("form/resetForm");
    };

    authService.addEmployment(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  addProjects() {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );

    let payload = {
      projectname: formBody.projectname,
      roles: formBody.role,
      description: formBody.description,
      startdate: formBody.startdate,
      enddate: formBody.enddate,
      projectlink: formBody.projectlink,
      skills: formBody.skills,
      applicantid: StoreUtils.rootGetters(
        StoreUtils.getters.applicant.GET_APPLICANT_ID
      )
    };

    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      StoreUtils.dispatch(StoreUtils.actions.applicant.FETCH_PROJECT_HISTORY);
      RouterUtils.replaceRoute(RouterUtils.routes.HOME.APPLICANT_HOME);
    };

    authService.addProjects(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },

  addApplicantDetail() {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );

    let object = StoreUtils.rootGetters(
      "applicant/getApplicantLocationProfileObj"
    );

    let payload = {
      ...formBody,
      skills: StoreUtils.rootGetters("auth/getApplicantRegSkills"),
      state: object.state,
      country: object.country,
      applicantid: StoreUtils.rootGetters(
        StoreUtils.getters.applicant.GET_APPLICANT_ID
      )
    };

    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      StoreUtils.dispatch(
        StoreUtils.actions.auth.APPLICANT_REFRESH_NON_BLOCKING
      );
      RouterUtils.changeRouteTo(RouterUtils.routes.auth.ADD_EDUCATION);
    };

    authService.addApplicantDetails(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  initiateEnrollment() {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );

    let payload = {
      userFirstname: formBody.userFirstname,
      userLastname: formBody.userLastname,
      userEmail: formBody.userEmail,
      userPhone: formBody.userPhone,
      userCountryCode: "234"
    };
    // console.log(payload);

    let successAction = responseData => {
      //Save user info to the store
      StoreUtils.commit("form/INCREASE_FORM_STAGE_BY_ONE");
    };

    authService.initiateEnrollment(
      payload,
      successAction,
      LoaderUtils.types.BLOCKING
    );
  },

  successfulLogin(undefined, { userInfo, role }) {
    StoreUtils.commit("auth/SET_AUTH_TOKEN", userInfo.token);
    StoreUtils.commit("user/SET_USER_INFO", userInfo);
    StoreUtils.commit("user/SET_USER_ROLE", role);
    RouterUtils.changeBaseRouteTo(RouterUtils.routes.DASHBOARD);
  },

  register(undefined, { formBody1, formBody2 }) {
    let payload = {
      ...formBody1,
      ...formBody2
    };
    let successAction = () => {
      let notificationModalBody = {
        type: NotificationUtils.type.SUCCESS, //error, success, warning
        mode: NotificationUtils.mode.YES, // default, yes-no
        title: "",
        message:
          "Your initial registration has been successfully competed!\n" +
          "A Choose Life representative will contact you to complete your \n" +
          "registration and to begin onboarding your organization.",
        noAction: () => {
          NotificationUtils.closeNotificationModal();
        },
        noActionTitle: "No",
        yesAction: () => {
          NotificationUtils.closeNotificationModal();
        },
        yesActionTitle: "Continue"
      };
      NotificationUtils.showNotificationModal(notificationModalBody);
    };
    return authService.register(
      payload,
      successAction,
      LoaderUtils.types.BLOCKING
    );
  },

  logIn(undefined, payload) {
    let successAction = responseData => {
      let userRole = responseData.user_role;
      StoreUtils.dispatch("auth/successfulLogin", {
        userInfo: responseData,
        role: userRole
      });
    };
    return authService.logIn(
      payload,
      successAction,
      LoaderUtils.types.BLOCKING
    );
  },

  // logOut() {
  //   StoreUtils.commit("auth/RESET_AUTH_TOKEN");
  //   let userRole = StoreUtils.rootGetters("user/getUserRole");
  //   if (
  //     userRole === AppUtils.parameters.user.roles.COMPANY_ADMIN ||
  //     userRole === AppUtils.parameters.user.roles.COMPANY_USER
  //   ) {
  //     RouterUtils.changeBaseRouteTo(RouterUtils.routes.auth.LOGIN);
  //   }
  //   if (
  //     userRole === AppUtils.parameters.user.roles.CHOOSE_LIFE_ADMIN ||
  //     userRole === AppUtils.parameters.user.roles.CHOOSE_LIFE_USER
  //   ) {
  //     RouterUtils.changeBaseRouteTo(RouterUtils.routes.auth.ADMIN_LOGIN);
  //   }
  // },

  createProfile(undefined, { formBody1, formBody2 }) {
    let payload = {
      ...formBody1,
      ...formBody2,
      business_id: StoreUtils.rootGetters("auth/getAuthBusinessId")
    };

    let successAction = () => {
      RouterUtils.changeBaseRouteTo(RouterUtils.routes.auth.LOGIN);
    };

    return authService.createProfile(
      payload,
      successAction,
      LoaderUtils.types.BLOCKING
    );
  },

  createRecruiter() {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );
    //add username
    formBody.username = formBody.email;
    //remove unnecessary properties
    delete formBody.checkbox_terms;

    StoreUtils.commit("auth/SET_MOBILE_NUMBER", formBody.mobilenumber);
    StoreUtils.commit("auth/SET_EMAIL", formBody.email);

    let successAction = responseData => {
      Utils.saveToLocalStorage(
        StoreUtils.localStorageStore.auth.RECRUITER_ID,
        responseData.userid
      );

      StoreUtils.dispatch("form/resetForm");
      RouterUtils.changeRouteTo(RouterUtils.routes.auth.RECRUITER_CONFIRM_OTP);
    };

    authService.createRecruiter(
      formBody,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },

  confirmRecruiterOTP() {
    let mobile = StoreUtils.rootGetters("auth/getMobileNumber");
    let otp = StoreUtils.rootGetters(
      StoreUtils.getters.auth.GET_USER_REG_TOKEN
    );

    let payload = {
      mobilenumber: mobile,
      otp: otp
    };

    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      RouterUtils.changeRouteTo(RouterUtils.routes.auth.LOGIN);
    };

    authService.confirmRecruiterOTP(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  addOrganization() {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );
    let recruiterid = Utils.getFromLocalStorage(
      StoreUtils.localStorageStore.auth.RECRUITER_ID
    );

    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
      StoreUtils.commit(StoreUtils.mutations.auth.SET_ACTION_MODAL_OPEN, true);
    };

    authService.addOrganization(
      { ...formBody, userid: recruiterid },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  postJob() {
    const formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );
    const { onDashboard } = formBody;
    delete formBody.onDashboard;

    const recruiterid = StoreUtils.rootGetters(
      StoreUtils.getters.recruiter.GET_RECRUITER_DETAILS
    ).organizationid;

    const skills = StoreUtils.rootGetters("auth/getApplicantRegSkills");

    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");

      if (onDashboard) RouterUtils.changeRouteUrlTo("/recruiter-jobs");
    };

    authService.postJob(
      { ...formBody, skills, recruiterid },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  seeTalents() {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );
    let recruiterid = Utils.getFromLocalStorage(
      StoreUtils.localStorageStore.auth.RECRUITER_ID
    );
    const skills = StoreUtils.rootGetters("auth/getApplicantRegSkills").join(
      ","
    );

    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
    };

    authService.seeTalents(
      { ...formBody, skills, recruiterid },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  recruiterAddProject() {
    let formBody = StoreUtils.rootGetters(
      StoreUtils.getters.form.GET_FORM_BODY
    );
    let recruiterid = Utils.getFromLocalStorage(
      StoreUtils.localStorageStore.auth.RECRUITER_ID
    );

    if (!recruiterid) {
      recruiterid = StoreUtils.rootGetters(
        StoreUtils.getters.applicant.GET_APPLICANT_ID
      );
    }

    const skills = StoreUtils.rootGetters("auth/getApplicantRegSkills").join(
      ","
    );

    let successAction = () => {
      StoreUtils.dispatch("form/resetForm");
    };

    authService.recruiterAddProject(
      { ...formBody, skills, recruiterid },
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  },
  applicantRefreshApi() {
    let successAction = responseData => {
      let userType = "applicant";

      if (responseData.educations) {
        //save applicant info
        StoreUtils.commit("applicant/SET_APPLICANT_INFO", responseData);
        StoreUtils.dispatch(
          StoreUtils.actions.applicant.FETCH_APPLICANT_INTERVIEWS
        );
        StoreUtils.dispatch(StoreUtils.actions.applicant.FETCH_OFFERS);
      } else {
        //save recruiter info
        userType = "recruiter";
        StoreUtils.commit(
          StoreUtils.mutations.recruiter.SET_RECRUITER_DETAILS,
          responseData.details
        );
      }

      StoreUtils.commit(StoreUtils.mutations.auth.SET_USER_TYPE, userType);
      StoreUtils.dispatch(StoreUtils.actions.auth.FETCH_DEGREES);
      StoreUtils.dispatch(StoreUtils.actions.applicant.FETCH_ROLES_AND_SKILLS);
    };

    authService.refreshApplicantDetails(
      {},
      successAction,
      LoaderUtils.types.BLOCKING
    );
  },
  applicantRefreshNonBlocking() {
    let successAction = responseData => {
      let userType = "applicant";

      if (responseData.educations) {
        StoreUtils.commit("applicant/SET_APPLICANT_INFO", responseData);
        StoreUtils.dispatch(
          StoreUtils.actions.applicant.FETCH_APPLICANT_INTERVIEWS
        );
        StoreUtils.dispatch(StoreUtils.actions.applicant.FETCH_OFFERS);
      } else {
        userType = "recruiter";

        StoreUtils.commit(
          StoreUtils.mutations.recruiter.SET_RECRUITER_DETAILS,
          responseData.details
        );
      }

      StoreUtils.commit(StoreUtils.mutations.auth.SET_USER_TYPE, userType);
      StoreUtils.dispatch(StoreUtils.actions.auth.FETCH_DEGREES);
      StoreUtils.dispatch(StoreUtils.actions.applicant.FETCH_ROLES_AND_SKILLS);
    };

    authService.refreshApplicantDetails(
      {},
      successAction,
      LoaderUtils.types.NONE
    );
  },
  // changePassword() {
  //   let formBody = StoreUtils.rootGetters(
  //     StoreUtils.getters.form.GET_FORM_BODY
  //   );
  //
  //   let payload = {
  //     currentpassword: formBody.currentpassword,
  //     newpassword: formBody.newpassword,
  //     userid: StoreUtils.rootGetters(
  //       StoreUtils.getters.applicant.GET_APPLICANT_ID
  //     )
  //   };
  //
  //   let successAction = () => {
  //     //  move to confirm otp
  //     // StoreUtils.commit(StoreUtils.mutations.auth.SET_PASSWORD, data.newpassword)
  //     StoreUtils.commit(
  //       StoreUtils.mutations.auth.SET_CHANGE_PASSWORD_SUCCESS,
  //       true
  //     );
  //     StoreUtils.dispatch("form/resetForm");
  //   };
  //
  //   authService.changePassword(
  //     payload,
  //     successAction,
  //     LoaderUtils.types.NONBLOCKING
  //   );
  // },
  fetchDegrees() {
    let payload = {};
    let successAction = response => {
      StoreUtils.commit(StoreUtils.mutations.auth.SET_DEGREES, response.data);
    };

    authService.fetchDegrees(
      payload,
      successAction,
      LoaderUtils.types.NONBLOCKING
    );
  }
};
